import { jsx } from "panel";
import { ItemsMenuEl } from "common/components/items-menu";
import { ToggleEl } from "common/components/toggle";
import { ToggleTheme } from "common/components/toggle/types";
import { SHORT_WINDOW_HEIGHT } from "common/constants";
import { DateTab } from "../types";
export function template() {
  const {
    t
  } = this.getContext("i18n");
  return /* @__PURE__ */ jsx("div", { sel: ".mp-date-bucket-pane", class: {
    "short-window": window.innerHeight <= SHORT_WINDOW_HEIGHT
  }, "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx(ToggleEl, { sel: ".toggle-el", attrs: {
    theme: ToggleTheme.TabBar,
    options: [{
      label: t("query-builder.buckets.time-unit"),
      value: DateTab.Unit,
      tooltipLabel: t("query-builder.buckets.time-unit-tooltip")
    }, {
      label: t("query-builder.buckets.iso-time"),
      value: DateTab.Iso,
      tooltipLabel: t("query-builder.buckets.iso-time-tooltip")
    }],
    selected: this.params.unit ? DateTab.Unit : DateTab.Iso
  }, on: {
    select: (ev) => this.handleTabClick(ev)
  }, "data-sentry-element": "ToggleEl", "data-sentry-source-file": "template.tsx" }), this.params.unit && /* @__PURE__ */ jsx(ItemsMenuEl, { props: {
    sections: this.getItemsMenuSections()
  }, on: {
    clickItem: (ev) => this.handleClickUnit(ev)
  } }), /* @__PURE__ */ jsx("div", { sel: ".bucket-preview" }, this.getPreviewForUnit(this.params.unit)));
}
